export default __webpack_public_path__ + "static/media/offer.8ebc029c.png";